import '@site/styles/sass/styles.scss';

import './vendor/element-closest';

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

import './module/lib/lastContent';
import './module/lib/screenReader';

import './module/menu';
import './module/breadcrumb';
// import './module/video';
// import './module/carousel';
import './module/scroll';

const printBtn = document.querySelector('.js-print');
if (printBtn) {
    printBtn.addEventListener('click', function (e) {
        e.preventDefault();
        window.print();
    });
}

const fileDownloads = document.querySelectorAll('.js-download');
for (let btn of fileDownloads) {
    btn.addEventListener('click', function (eve) {
        var url = this.getAttribute('data-href');
        var fileName = this.getAttribute('download');
        var xhr = new XMLHttpRequest();

        xhr.open('GET', url, true);
        xhr.responseType = 'blob';

        xhr.onload = function () {
            var urlCreator = window.URL || window.webkitURL;
            var imageUrl = urlCreator.createObjectURL(this.response);
            var tag = document.createElement('a');
            tag.href = imageUrl;
            tag.download = fileName;
            document.body.appendChild(tag);
            tag.click();
            document.body.removeChild(tag);
            link.innerText = 'Download Image';
        };

        xhr.send();
    });
}

/* added _blank for all external links */
const allLinks = document.querySelectorAll('[href^=http]');
for(let linkElem of allLinks) {
    if(linkElem.href.indexOf(window.location.hostname) < 0) {
        linkElem.setAttribute('target', '_blank');
    }
}

const copyLink = document.querySelector('.js-copy-link');
if (copyLink) {
    copyLink.addEventListener('click', function (e) {
        e.preventDefault();
        const cb = navigator.clipboard;
        cb.writeText(window.location.href).then(() => alert('Link copied'));
    });
}